import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import BorderGlow from "../components/BorderGlow";
import { API_BASE } from "../config/api";
import "./login.css"; // reuse login styles

const Signup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length < 8) {
      alert("Password must be at least 8 characters");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE}/api/auth/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            password: formData.password,
          }),
        }
      );

      const contentType = res.headers.get("content-type") || "";
      const data = contentType.includes("application/json") ? await res.json() : {};

      if (!res.ok) {
        alert(data.message || "Registration failed");
        return;
      }

      alert("OTP sent to your email. Please verify.");
      navigate("/verify-email", { state: { email: formData.email } });
    } catch (err) {
      console.error("Registration error:", err);
      alert(`Something went wrong connecting to server (${API_BASE})`);
    }
  };

  return (
    <div className="login-page">
      <BorderGlow
        className="login-card-glow"
        backgroundColor="#1e293b"
        borderRadius={16}
        glowRadius={35}
        glowColor="240 80 80"
        colors={['#60a5fa', '#ec4899', '#8b5cf6']}
      >
        <div className="login-card-inner">

        <div className="login-header">
          <img src="/images/logo.png" alt="YUVA" />
          <h2>Create your account</h2>
          <p>Join the YUVA community</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Full name"
            required
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email address"
            required
            onChange={handleChange}
          />

          <input
            type="password"
            name="password"
            placeholder="Password (min 8 characters)"
            required
            onChange={handleChange}
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm password"
            required
            onChange={handleChange}
          />

          <button type="submit" className="login-btn">
            Create Account
          </button>
        </form>

        <p className="signup-text">
          Already have an account?{" "}
          <Link to="/login">Sign in</Link>
        </p>

        </div>
      </BorderGlow>
    </div>
  );
};

export default Signup;
